import React, { useEffect, useState } from "react"
import { imageSizingMapping } from "../../globals/variables";
import ProjFullImage from "../ProjFullImage/ProjFullImage";
import ProjRollingImage from "../projRollingImage/ProjRollingImage";
import ProjBoldQuoteImage from "../ProjBoldQuoteImage/ProjBoldQuoteImage";
import ProjVariableSection from "../ProjVariableSection/ProjVariableSection";

const ProjectStillsOrganiser = ({data}) => {
    const [fullHeroSrcType, setFullHeroSrcType] = useState(null);
    const [halfHeroSrcType, setHalfHeroSrcType] = useState(null);
    const [threeQuarterHeroSrcType, setThreeQuarterHeroSrcType] = useState(null);

    const [firstItemData, setFirstItemData] = useState(null);
    const [lastItemData, setLastItemData] = useState(null);
    const [rollingImageData, setRollingImageData] = useState(null);
    const [variableSection, setVariableSection] = useState(null);

    const responsiveHandler = () => {
        let fullWidth = window.innerWidth;
        let halfWidth = fullWidth/2;
        let threeQuarterWidth = 3*(fullWidth/4);

        let fullTargetSrc = null;
        let halfTargetSrc = null;
        let threeQuarterTargetSrc = null
        Object.entries(imageSizingMapping).forEach(([key, value]) => {
            if(fullWidth>= value[0] && fullWidth <= value[1]){
                fullTargetSrc = key;
            }
            if(halfWidth>= value[0] && halfWidth <= value[1]){
                halfTargetSrc = key;
            }
            if(threeQuarterWidth>= value[0] && threeQuarterWidth <= value[1]){
                threeQuarterTargetSrc = key;
            }
        });
        setFullHeroSrcType(fullTargetSrc);
        setHalfHeroSrcType(halfTargetSrc);
        setThreeQuarterHeroSrcType(threeQuarterTargetSrc);
    }

    const replaceSource = (inp, replaceWith) => {
        return(inp.replace("mobile", replaceWith))
    }

    useEffect(() => {
        // Set data
        if(fullHeroSrcType && halfHeroSrcType && threeQuarterHeroSrcType){
            // Assume MINIMUM of 5 stills
            let numberOfStills = data.stills.length;
            let firstImageData = data.stills[0];
            let imageRollingLyrics = data.stills[1];
            let imageVariableSection = data.stills.slice(2, data.stills.length - 1);
            let lastImageData = data.stills[data.stills.length - 1];

            firstImageData.backgroundImage = replaceSource(firstImageData.backgroundImage, fullHeroSrcType)
            lastImageData.backgroundImage = replaceSource(lastImageData.backgroundImage, threeQuarterHeroSrcType);
            imageRollingLyrics.backgroundImage = replaceSource(imageRollingLyrics.backgroundImage, halfHeroSrcType);
            setFirstItemData(firstImageData);
            setVariableSection(imageVariableSection);
            setRollingImageData(imageRollingLyrics);
            setLastItemData(lastImageData);
        }   
    }, [fullHeroSrcType, halfHeroSrcType, threeQuarterHeroSrcType])

    useEffect(()  => {  
        responsiveHandler()
        window.addEventListener('resize', responsiveHandler)
    }, [])
    return(
        <>
            {/* 
                // First image is always large HERO
                // second image is always small thumbnail lyrics
                // Variable section
                    // if one then offset hero
                    // if two then lyric pairing duo
                    // if three then offset hero + lyric pairing
                    // if four then offset hero + lyric pairing + offset hero/full hero
                // Last image is ALWAYS offset Quote
            */}
            {firstItemData &&
                <ProjFullImage 
                    data={firstItemData}
                    content={data.content}
                    isFirstItem={true}
                    aspectRatio={data.aspectRatio}
                />
            }
            {rollingImageData && 
                <ProjRollingImage
                    data={rollingImageData}
                    content={data.content}
                    isFirstItem={true}
                    aspectRatio={data.aspectRatio}
                />
            }
            {
                variableSection && 
                <ProjVariableSection
                    data={variableSection}
                    fullSize={fullHeroSrcType}
                    halfSize={halfHeroSrcType}
                    threeQSize={threeQuarterHeroSrcType}
                    content={data.content}
                    aspectRatio={data.aspectRatio}
                />
            }
            {
                lastItemData &&
                <ProjBoldQuoteImage 
                    data={lastItemData}
                    content={data.content}
                    aspectRatio={data.aspectRatio}
                />
            }
        </>
    )
}

export default ProjectStillsOrganiser;